import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { REQUEST_STATE } from "../../dataTypes";
import { updateUserAccessMessage } from "../../userAccessMessage/reducers/updateUserAccessMessage";
import { SessionState } from "../dataTypes";

export const addUpdateUserAccessMessageReducers = (builder: ActionReducerMapBuilder<SessionState>) => {
  builder.addCase(updateUserAccessMessage.pending, (state, action) => {
    const id = action.meta.arg.id;

    if (id === state.nextUserAccessMessage?.id) {
      state.nextUserAccessMessage.requestState = REQUEST_STATE.PENDING;
      state.nextUserAccessMessage.errorMessage = undefined;
    }
  });
  builder.addCase(updateUserAccessMessage.fulfilled, (state, action) => {
    const {
      payload,
      meta: {
        arg: { id },
      },
    } = action;

    if (id === state.nextUserAccessMessage?.id) {
      state.nextUserAccessMessage = {
        id: payload?.id,
        fetchedTimestamp: Date.now(),
        requestState: REQUEST_STATE.FULFILLED,
      };
    }
  });
  builder.addCase(updateUserAccessMessage.rejected, (state, action) => {
    const id = action.meta.arg.id;

    if (id === state.nextUserAccessMessage?.id) {
      state.nextUserAccessMessage.requestState = REQUEST_STATE.REJECTED;
      state.nextUserAccessMessage.errorMessage = action.payload?.message;
    }
  });
};
